import React, {useState, useContext, useEffect, useCallback} from 'react'
import {useHistory} from 'react-router-dom'

import {BackgroundMusicContext} from '../../context/BackgroundMusicContext'
import useAuthentication from '../../hooks/useAuthentication'

function LoginForm({userKey, setUserKey, togglePopUp, loading, setLoading}) {
    const [localKey, setLocalKey] =             
          useState(window.localStorage.getItem('localKey'))
    const {logIn} = useAuthentication()
    const {loadTrack} = useContext(BackgroundMusicContext)
    const route = useHistory()
    
    function handleChange(event) {
        const {value} = event.target
        setUserKey(value)
    } 
    
    function handleSubmit(event) {
        event.preventDefault()
        attemptLogIn(userKey)
    }
    
    const attemptLogIn = useCallback( async (userKey) => {
        setLoading(true)
        try{
            const result = await logIn(userKey)
            loadTrack()
            route.push(result)
        }catch(err){
            localKey && setLocalKey(undefined)
            setUserKey('')
            togglePopUp()
            setLoading(false)
        }
    }, [logIn, route, setUserKey, togglePopUp, loadTrack, localKey, setLocalKey, setLoading])
    
    useEffect(() => {
        !loading && localKey && attemptLogIn(localKey)
    }, [localKey, loading, attemptLogIn])
        
    return (
        <>
            <h2 className="keyPanel_title">
                Please enter your product key to play
            </h2>
            <form onSubmit={handleSubmit}>
                <input
                    className="keyPanel_input"
                    placeholder="Product Key"
                    aria-label='enter product key'
                    value={userKey}
                    onChange={handleChange}
                />
                <button
                    type='submit'
                    className='login_btn'
                >
                    Submit
                </button>
            </form>
        </>
    )
}

export default LoginForm